import { Currency } from '../interfaces';
import { IUploadFileCondition } from '../modals/file-upload-new/file-upload-new.interface';
import { ITheme } from '../modals/themes/themes.interface';
import { TReaction } from '../components/reaction/reaction.interface';
import { CrmService } from '../services/crm.service';
import {
  activeTranslations,
  languages,
  liveObject,
  onLiveTranslationsChange,
} from '../core/i18n/live-translations';

/**
 * Живий словник перекладів для «статичного» коду (реекспорт із core/i18n).
 *
 * `activeTranslations` — основний спосіб читати переклади: це словник мови,
 * яку застосунок показує зараз. `languages` лишається для рідкісних випадків,
 * коли потрібна конкретна мова, а не активна. Див. docs/I18N.md.
 */
export { activeTranslations, languages };


export const NAME_PROJECT: string = 'JECRM';
/**
 * Текст помилки за замовчуванням. `let`, а не `const`: значення живе,
 * бо оновлюється при зміні мови без перезавантаження сторінки.
 */
export let DEFAULT_ERROR: string = '';
onLiveTranslationsChange(() => {
  DEFAULT_ERROR = activeTranslations.errors.default_error || '';
});

export const ERROR_MESSAGES: Record<string, string> = liveObject(() => ({
  INTERNAL_ERROR: DEFAULT_ERROR,

  ADVERT_CANNOT_SPECIFIED_CURRENCY: activeTranslations.errors.advert_cannot_specified_currency,

  PROMO_CODE_EXPIRED: activeTranslations.errors.promo_code_expired,
  ACCOUNT_OLX_EXPIRED: activeTranslations.errors.account_olx_expired,

  TOO_MANY_REQUESTS: activeTranslations.errors.too_many_requests,
  EXPIRED_OTP: activeTranslations.errors.expired_otp,
  INVALID_OTP_CODE: activeTranslations.errors.invalid_otp_code,

  PHONE_NUMBER_INVALID: activeTranslations.errors.phone_number_invalid,
  PHONE_NUMBER_UNOCCUPIED: activeTranslations.errors.phone_number_unoccupied,
  PHONE_NUMBER_FLOOD: activeTranslations.errors.phone_number_flood,
  PHONE_NUMBER_BANNED: activeTranslations.errors.phone_number_banned,
  PHONE_CODE_INVALID: activeTranslations.errors.phone_code_invalid,
  PHONE_CODE_EXPIRED: activeTranslations.errors.phone_code_expired,
  PHONE_CODE_EMPTY: activeTranslations.errors.phone_code_empty,
  PHONE_PASSWORD_FLOOD: activeTranslations.errors.phone_password_flood,
  PHONE_PASSWORD_PROTECTED: activeTranslations.errors.phone_password_protected,
  PASSWORD_HASH_INVALID: activeTranslations.errors.password_hash_invalid,
  SMS_CODE_CREATE_FAILED: activeTranslations.errors.sms_code_create_failed,
  CHANNEL_HAS_ANOTHER_PHONE: activeTranslations.errors.channel_has_another_phone,

  MAX_FILE_SIZE: activeTranslations.errors.max_file_size,
  MAX_MEMORY_LIMIT_REACHED: activeTranslations.errors.max_memory_limit_reached,
  MAX_INTEGRATION: activeTranslations.errors.max_integration,
  TOO_HIGH_ADVERT_PRICE: activeTranslations.errors.too_high_advert_price,

  USER_NOT_FOUND: activeTranslations.errors.user_not_found,
  INTEGRATION_NOT_FOUND: activeTranslations.errors.integration_not_found,

  CONTACT_ALREADY_EXISTS: activeTranslations.errors.contact_already_exists,
  PHONE_ALREADY_EXISTS: activeTranslations.errors.phone_already_exists,
  DOMAIN_ALREADY_EXISTS: activeTranslations.errors.domain_already_exists,
  INTEGRATION_ALREADY_EXISTS: activeTranslations.errors.integration_already_exists,
  INTEGRATION_ALREADY_EXISTS_IN_ANOTHER_COMPANY: activeTranslations.errors.integration_already_exists_in_another_company,
  COLUMN_ALREADY_EXISTS: activeTranslations.errors.column_already_exists,
  CUSTOM_FIELD_ALREADY_EXISTS: activeTranslations.errors.custom_field_already_exists,
  USER_ALREADY_EXISTS: activeTranslations.errors.user_already_exists,
  CHANNEL_USER_ALREADY_EXISTS: activeTranslations.errors.channel_user_already_exists,
  CHAT_DISTRIBUTION_CHANNEL_CONFLICT: activeTranslations.errors.chat_distribution_channel_conflict,

  USER_ALREADY_INVITED: activeTranslations.errors.user_already_invited,
  CURRENT_EMAIL_EXISTS: activeTranslations.errors.current_email_exists,

  ACCOUNT_OLX_PAUSE: activeTranslations.errors.account_olx_pause,

  ACCESS_REJECTED: activeTranslations.errors.access_rejected,
  CHANNEL_ALREADY_EXISTS: activeTranslations.errors.channel_already_exists,
  FUNNEL_ALREADY_EXISTS: activeTranslations.errors.funnel_already_exists,
  EMPTY_FIELD_NAME: activeTranslations.errors.empty_field_name,
  EMPTY_FIELD_ACTION: activeTranslations.errors.empty_field_action,
  EMPTY_FIELD_TRIGGER: activeTranslations.errors.empty_field_trigger,
  EMPTY_FIELD_TIME: activeTranslations.errors.empty_field_time,
  EMPTY_FIELD_CHANNEL: activeTranslations.errors.empty_field_channel,
  NOT_ENOUGH_CREDITS: activeTranslations.errors.not_enough_credits,
  ADVERT_NOT_BELONGS_TO_PARTNER: activeTranslations.errors.redo_the_ad,
  FILE_SIZE_IS_TO_LARGE: activeTranslations.errors.file_size_is_to_large,

  //AUTH
  EMAIL_ALREADY_EXIST: activeTranslations.errors.email_already_exist,
  INVALID_CREDENTIALS: activeTranslations.errors.invalid_credentials,
  NOT_VERIFIED_EMAIL: activeTranslations.errors.not_verified_email,

  //INST
  MAX_INST_COMMENT_LENGTH: activeTranslations.errors.max_inst_comment_length,
  MAX_INST_MESSAGE_LENGTH: activeTranslations.errors.max_inst_message_length,
  MAX_INST_MEDIA_SIZE: activeTranslations.errors.max_inst_media_size,
  INST_CANNOT_DO_ACTION_AFTER_PERIOD: activeTranslations.errors.cannot_do_action_after_period,
  INST_UNSUPPORTED_FILE_TYPE: activeTranslations.errors.instagram_unsupported_file,
  INSTAGRAM_TOKEN_EXPIRED: activeTranslations.errors.instagram_token_expired,

  //VIBER
  CHAT_IS_NOT_AVAILABLE: activeTranslations.errors.chat_is_not_available,
  VIBER_SEND_MESSAGE_ERROR: activeTranslations.errors.viber_send_message_error,
  LOGIN_BLOCKED: activeTranslations.errors.login_blocked,
  LOGIN_TIMEOUT: activeTranslations.errors.login_timeout,

  NEED_TO_CONNECT_CHANNEL_FOR_ACTION: activeTranslations.errors.need_connect_channel_for_action,
  TOKEN_IS_INVALID: activeTranslations.errors.invalid_token,
  SUBDOMAIN_IS_INVALID: activeTranslations.errors.invalid_subdomain,
  YOU_CANNOT_WRITE_MESSAGE_YOURSELF: activeTranslations.errors.you_cannot_write_message_yourself,
  IP_ACCESS_DENIED: activeTranslations.errors.ip_access_denied,
  MESSAGE_HAS_NO_MEDIA: activeTranslations.errors.message_has_no_media,
  NOTHING_TO_TRANSLATE: activeTranslations.errors.nothing_to_translate,
  PAYMENT_PRICE_MISMATCH: activeTranslations.errors.payment_price_mismatch,
}), { fallback: () => DEFAULT_ERROR });

export const DEFAULT_ERROR_STRING: string = 'errors.default_error';
export const ERROR_MESSAGES_STRING: Record<string, string> = {
  INTERNAL_ERROR: 'errors.internal_error',
  ADVERT_NOT_FOUND: 'errors.advert_not_found',
  ACTIVE_ADVERTS_LIMIT_REACHED: 'errors.active_adverts_limit_reached',
  ADVERT_DATA_VALIDATION_ERROR: 'errors.advert_data_validation_error',
  ADVERT_CANNOT_SPECIFIED_CURRENCY: 'errors.advert_cannot_specified_currency',
  TOO_HIGH_ADVERT_PRICE: 'errors.too_high_advert_price',
  TOO_LOW_ADVERT_PRICE: 'errors.too_low_advert_price',
  NOT_ENOUGH_CREDITS: 'errors.not_enough_credits',
  ADVERT_NOT_BELONGS_TO_PARTNER: 'errors.redo_the_ad',
  ADVERT_NOT_COMPLY_TERMS_OF_USE: 'errors.advert_not_comply_terms_of_use',
  ADVERT_ALREADY_BEEN_PLACED: 'errors.advert_already_been_placed',
  ADVERT_MUST_BE_ACTIVE: 'errors.advert_must_be_active',
  ADVERT_MUST_BE_DEACTIVATED: 'errors.advert_must_be_deactivated',
  FIELD_CONTAINS_INVALID_CHARACTERS: 'errors.field_contains_invalid_characters',
  PRODUCT_ALREADY_APPLIED: 'errors.product_already_applied',
  INVALID_TOKEN: 'errors.invalid_token',
  IMAGE_WIDTH_MUST_BE_AT_LEAST: 'errors.image_width_must_be_at_least',
  COULD_NOT_FETCH_IMAGE: 'errors.could_not_fetch_image',
  ZONE_ID_MUST_BE_NUMERIC: 'errors.zone_id_must_be_numeric',
  CATEGORY_NOT_FOUND: 'errors.category_not_found',
  EXTERNAL_CHAT_NOT_FOUND: 'errors.external_chat_not_found',
  TOKENS_EXHAUSTED: 'errors.tokens_exhausted',
  MESSAGE_HAS_NO_MEDIA: 'errors.message_has_no_media',
  NOTHING_TO_TRANSLATE: 'errors.nothing_to_translate',
  CHAT_DISTRIBUTION_CHANNEL_CONFLICT: 'errors.chat_distribution_channel_conflict',
};

export const quotes = [
  {
    'text': 'Якщо хочеш прямувати новим шляхом, ти мусиш прокласти його самотужки',
    'author': '',
  },
  {
    'text': 'Дай кожному дню шанс стати найпрекраснішим у твоєму житті!',
    'author': '',
  },
  {
    'text': 'Сильна людина не та, яка може собі багато дозволити, а та яка може багато від чого відмовитися.',
    'author': '',
  },
  {
    'text': 'Ніколи не пізно ставити нові цілі і мріяти про щось більше.',
    'author': ' ',
  },
  {
    'text': 'Умій відпускати, хоча б тому, що вантаж минулого занадто важкий, щоб нести його на собі.',
    'author': '',
  },
  {
    'text': 'Найважчий поєдинок – це коли за успіх доводиться боротися з лінню.',
    'author': ' ',
  },
  {
    'text': 'Поки ми відкладаємо життя, воно проходить.',
    'author': '',
  },
  {
    'text': 'Будьте щасливі тут і зараз, інакше це ніколи не трапиться.',
    'author': '',
  },
  {
    'text': 'Ви отримуєте від життя лише те, що наважуєтеся попросити. Не бійтеся підвищувати планку. ',
    'author': '',
  },
  {
    'text': 'Якщо ви не здаєтеся, це має значення',
    'author': '',
  },
  {
    'text': 'Почніть робити те, що потрібно. Потім робіть те, що можливо. І ви раптом виявите, що робите неможливе.',
    'author': '',
  },
  {
    'text': 'Ми знаємо, хто ми є, але не знаємо, ким ми можемо бути.',
    'author': '',
  },
  {
    'text': 'Будь собою, інші ролі зайняті. ',
    'author': '',
  },
  {
    'text': 'Якщо ви робите те, що любите, ви ніколи не працюватимете жодного дня у своєму житті.',
    'author': '',
  },
  {
    'text': 'Навчання ніколи не вичерпує розум.',
    'author': ' ',
  },
  {
    'text': 'Ваше благополуччя залежить від ваших власних рішень',
    'author': '',
  },
  {
    'text': 'Щастя – це не щось готове. Щастя залежить тільки від ваших дій. ',
    'author': '',
  },
  {
    'text': 'Якщо немає вітру, беріться за весла.',
    'author': '',
  },
  {
    'text': 'Ми стаємо тим, про що ми думаємо.',
    'author': '',
  },
  {
    'text': 'Прагніть бути не просто успішною людиною, а цінним.',
    'author': '',
  },
  {
    'text': 'Використовуй час з користю',
    'author': 'JECRM',
  },
];

export enum STATUSES_NOVA_TRACKING {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  GOTTEN = 'GOTTEN',
  NOT_FOUND = 'NOT_FOUND',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
  ARRIVED = 'ARRIVED',
  CANCELED = 'CANCELED',
  ARRIVED_3 = 'ARRIVED_3',
}

export enum STATUSES_UKR_TRACKING {
  REGISTERED = 'REGISTERED',
  DELIVERING = 'DELIVERING',
  ERROR = 'ERROR',
  IN_DEPARTMENT = 'IN_DEPARTMENT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  RETURNING = 'RETURNING',
  FORWARDING = 'FORWARDING',
  CANCELLED = 'CANCELLED',
  STORAGE = 'STORAGE',
}

export enum STATUSES_OLX_ADVERT {
  ACTIVE = 'active',
  NEW = 'new',
  DISABLED = 'disabled',
  REMOVED_BY_USER = 'removed_by_user',
  OUTDATED = 'outdated',
  LIMITED = 'limited',
  MODERATED = 'moderated',
}

export const status_table_olx_adverts = (status: string): any => {
  switch (status) {
    case STATUSES_OLX_ADVERT.ACTIVE:
      return {
        icon: 'check_circle',
        text: activeTranslations.olx.adverts.active,
        color: 'green',
      };
    case STATUSES_OLX_ADVERT.NEW:
      return {
        icon: 'watch_later',
        text: activeTranslations.olx.adverts.pending,
        color: 'gray',
      };
    case STATUSES_OLX_ADVERT.DISABLED:
      return {
        icon: 'watch_later',
        text: activeTranslations.olx.adverts.pending,
        color: 'gray',
      };
    case STATUSES_OLX_ADVERT.REMOVED_BY_USER:
      return {
        icon: 'warning',
        text: activeTranslations.olx.adverts.inactive,
        color: 'orange',
      };
    case STATUSES_OLX_ADVERT.OUTDATED:
      return {
        icon: 'warning',
        text: activeTranslations.olx.adverts.inactive,
        color: 'orange',
      };
    case STATUSES_OLX_ADVERT.LIMITED:
      return {
        icon: 'monetization_on',
        text: activeTranslations.olx.adverts.unpaid,
        color: 'orangered',
      };
    default:
      return {
        icon: 'search_off',
        text: activeTranslations.status_table_nova_poshta.not_found,
        color: 'gray',
      };
  }
};

export const status_table_nova_poshta = (status: string): any => {
  switch (status) {
    case STATUSES_UKR_TRACKING.REGISTERED:
      return {
        icon: 'add_circle',
        text: activeTranslations.status_table_nova_poshta.registered,
        color: 'green',
      };
    case STATUSES_UKR_TRACKING.DELIVERING:
      return {
        icon: 'local_shipping',
        text: activeTranslations.status_table_nova_poshta.delivering,
        color: '#3072ef',
      };
    case STATUSES_UKR_TRACKING.DELIVERED:
      return {
        icon: 'check_circle',
        text: activeTranslations.status_table_nova_poshta.delivered,
        color: 'green',
      };
    case STATUSES_UKR_TRACKING.IN_DEPARTMENT:
      return {
        icon: 'inventory',
        text: activeTranslations.status_table_nova_poshta.in_department,
        color: 'orange',
      };
    case STATUSES_UKR_TRACKING.RETURNED:
      return {
        icon: 'inventory',
        text: activeTranslations.status_table_nova_poshta.returned,
        color: 'red',
      };
    case STATUSES_UKR_TRACKING.RETURNING:
      return {
        icon: 'cancel',
        text: activeTranslations.status_table_nova_poshta.returning,
        color: 'red',
      };
    case STATUSES_UKR_TRACKING.FORWARDING:
      return {
        icon: 'local_shipping',
        text: activeTranslations.status_table_nova_poshta.forwarding,
        color: 'green',
      };
    case STATUSES_UKR_TRACKING.CANCELLED:
      return {
        icon: 'cancel',
        text: activeTranslations.status_table_nova_poshta.canceled,
        color: 'red',
      };
    case STATUSES_UKR_TRACKING.STORAGE:
      return {
        icon: 'inventory',
        text: activeTranslations.status_table_nova_poshta.storage,
        color: 'inventory',
      };
    case STATUSES_UKR_TRACKING.ERROR:
      return {
        icon: 'error',
        text: activeTranslations.status_table_nova_poshta.error,
        color: 'red',
      };
    case STATUSES_NOVA_TRACKING.CREATED:
      return {
        icon: 'add_circle',
        text: activeTranslations.status_table_nova_poshta.registered,
        color: 'green',
      };
    case STATUSES_NOVA_TRACKING.COMPLETED:
      return {
        icon: 'check_circle',
        text: activeTranslations.status_table_nova_poshta.completed,
        color: 'green',
      };
    case STATUSES_NOVA_TRACKING.ERROR:
      return {
        icon: 'error',
        text: activeTranslations.status_table_nova_poshta.error,
        color: 'red',
      };
    case STATUSES_NOVA_TRACKING.GOTTEN:
      return {
        icon: 'check_circle',
        text: activeTranslations.status_table_nova_poshta.gotten,
        color: 'green',
      };
    case STATUSES_NOVA_TRACKING.NOT_FOUND:
      return {
        icon: 'search_off',
        text: activeTranslations.status_table_nova_poshta.not_found,
        color: 'gray',
      };
    case STATUSES_NOVA_TRACKING.DELETED:
      return {
        icon: 'delete',
        text: activeTranslations.status_table_nova_poshta.deleted,
        color: 'red',
      };
    case STATUSES_NOVA_TRACKING.PENDING:
      return {
        icon: 'local_shipping',
        text: activeTranslations.status_table_nova_poshta.delivering,
        color: '#3072ef',
      };
    case STATUSES_NOVA_TRACKING.ARRIVED:
      return {
        icon: 'inventory',
        text: activeTranslations.status_table_nova_poshta.delivered,
        color: 'orange',
      };
    case STATUSES_NOVA_TRACKING.ARRIVED_3:
      return {
        icon: 'inventory',
        text: activeTranslations.status_table_nova_poshta.in_department,
        color: 'red',
      };
    case STATUSES_NOVA_TRACKING.CANCELED:
      return {
        icon: 'cancel',
        text: activeTranslations.status_table_nova_poshta.canceled,
        color: 'red',
      };
    default:
      return {
        icon: 'search_off',
        text: activeTranslations.status_table_nova_poshta.not_found,
        color: 'gray',
      };
  }
};

export const status_table_planner = (status: string): any => {
  switch (status) {
    case ADVERT_PLANNER_STATUS.CREATED:
      return {
        icon: 'task',
        text: activeTranslations.status_table_planner.created,
        color: 'green',
      };
    case ADVERT_PLANNER_STATUS.WAITING:
      return {
        icon: 'pending',
        text: activeTranslations.status_table_planner.waiting,
        color: 'grey',
      };
    case ADVERT_PLANNER_STATUS.FAIL:
      return {
        icon: 'error',
        text: activeTranslations.status_table_planner.fail,
        color: 'red',
      };
    case ADVERT_PLANNER_STATUS.COMPLETED:
      return {
        icon: 'check_circle',
        text: activeTranslations.status_table_planner.completed,
        color: 'green',
      };
    case ADVERT_PLANNER_STATUS.CANCELED:
      return {
        icon: 'cancel',
        text: activeTranslations.status_table_planner.canceled,
        color: 'red',
      };
    case ADVERT_PLANNER_STATUS.DRAFT:
      return {
        icon: 'description',
        text: activeTranslations.status_table_planner.draft,
        color: 'gray',
      };
    case ADVERT_PLANNER_STATUS.PROGRESS:
      return {
        icon: 'autorenew',
        text: activeTranslations.status_table_planner.progress,
        color: 'gray',
      };
    default:
      return {
        icon: 'search_off',
        text: activeTranslations.status_table_planner.not_found,
        color: 'gray',
      };
  }
};

export enum LOGISTIC_TYPES {
  NOVA_POSHTA = 'NOVA_POSHTA',
  UKR_POSHTA = 'UKR_POSHTA',
  MEEST = 'MEEST',
}

export const LOGISTICS = {
  NOVA_POSHTA: 'Нова Пошта',
  UKR_POSHTA: 'Укр Пошта',
  MEEST: 'Міст',
};

export const LOGISTICS_LOGOS = {
  NOVA_POSHTA: '/assets/svgs/integrations/nova_poshta.svg',
  UKR_POSHTA: '/assets/svgs/integrations/ukr_poshta_icon.svg',
  MEEST: '/assets/svgs/integrations/meest.svg',
};

export enum CHAT_EXTERNAL_TYPE {
  OLX = 'OLX',
  PROM = 'PROM',
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  ROZETKA = 'ROZETKA',
  IZI = 'IZI',
  INTERNAL = 'INTERNAL',
  TELEGRAM_BOT = 'TELEGRAM_BOT',
  TELEGRAM_USER = 'TELEGRAM_USER',
  RIA = 'RIA',
  AUTO_RIA = 'AUTO_RIA',
  DOM_RIA = 'DOM_RIA',
  AGRO_RIA = 'AGRO_RIA',
  RIA_WH = 'RIA_WH',
  AUTO_RIA_WH = 'AUTO_RIA_WH',
  DOM_RIA_WH = 'DOM_RIA_WH',
  AGRO_RIA_WH = 'AGRO_RIA_WH',
  CHAT_WIDGET = 'CHAT_WIDGET',
  VIBER = 'VIBER',
  WHATSAPP = 'WHATSAPP',
  TIKTOK = 'TIKTOK',
}

export enum SENDER_TYPES {
  OPPONENT = 'OPPONENT',
  SENT = 'SENT',
  SENT_AI = 'SENT_AI'
}

export enum CHAT_TYPES {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export enum ADVERT_TYPE {
  OLX = 'OLX',
  RIA = 'RIA',
}

export enum FUNNEL_TYPE {
  DEAL = 'DEAL',
  LEAD = 'LEAD',
}

export enum FUNNEL_STATUS {
  DEFAULT = 'DEFAULT',
  GENERAL = 'GENERAL',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
}

export enum COLUMN_CARD_STATUS {
  PROGRESS = 'PROGRESS',
  SUCCESSFULLY = 'SUCCESSFULLY',
  FAIL = 'FAIL'
}

export const DOLLAR = 38.30;

export const keyboards: any = {
  uk: {
    'q': 'й',
    'w': 'ц',
    'e': 'у',
    'r': 'к',
    't': 'е',
    'y': 'н',
    'u': 'г',
    'i': 'ш',
    'o': 'щ',
    'p': 'з',
    '[': 'х',
    ']': 'ї',
    'a': 'ф',
    's': 'і',
    'd': 'в',
    'f': 'а',
    'g': 'п',
    'h': 'р',
    'j': 'о',
    'k': 'л',
    'l': 'д',
    ';': 'ж',
    '\'': 'є',
    'z': 'я',
    'x': 'ч',
    'c': 'с',
    'v': 'м',
    'b': 'и',
    'n': 'т',
    'm': 'ь',
    ',': 'б',
    '.': 'ю',
    '/': '.',
    'Q': 'Й',
    'W': 'Ц',
    'E': 'У',
    'R': 'К',
    'T': 'Е',
    'Y': 'Н',
    'U': 'Г',
    'I': 'Ш',
    'O': 'Щ',
    'P': 'З',
    '{': 'Х',
    '}': 'Ї',
    'A': 'Ф',
    'S': 'І',
    'D': 'В',
    'F': 'А',
    'G': 'П',
    'H': 'Р',
    'J': 'О',
    'K': 'Л',
    'L': 'Д',
    ':': 'Ж',
    '"': 'Є',
    'Z': 'Я',
    'X': 'Ч',
    'C': 'С',
    'V': 'М',
    'B': 'И',
    'N': 'Т',
    'M': 'Ь',
    '<': 'Б',
    '>': 'Ю',
    '?': '.',
    '@': '"',
    '#': '№',
    '$': ';',
    '^': ':',
    '&': '?',
  },
  en: {
    'й': 'q',
    'ц': 'w',
    'у': 'e',
    'к': 'r',
    'е': 't',
    'н': 'y',
    'г': 'u',
    'ш': 'i',
    'щ': 'o',
    'з': 'p',
    'х': '[',
    'ї': ']',
    'ф': 'a',
    'і': 's',
    'в': 'd',
    'а': 'f',
    'п': 'g',
    'р': 'h',
    'о': 'j',
    'л': 'k',
    'д': 'l',
    'ж': ';',
    'є': '\'',
    'я': 'z',
    'ч': 'x',
    'с': 'c',
    'м': 'v',
    'и': 'b',
    'т': 'n',
    'ь': 'm',
    'б': ',',
    'ю': '.',
    '.': '/',
    'Й': 'Q',
    'Ц': 'W',
    'У': 'E',
    'К': 'R',
    'Е': 'T',
    'Н': 'Y',
    'Г': 'U',
    'Ш': 'I',
    'Щ': 'O',
    'З': 'P',
    'Х': '{',
    'Ї': '}',
    'Ф': 'A',
    'І': 'S',
    'В': 'D',
    'А': 'F',
    'П': 'G',
    'Р': 'H',
    'О': 'J',
    'Л': 'K',
    'Д': 'L',
    'Ж': ':',
    'Є': '"',
    'Я': 'Z',
    'Ч': 'X',
    'С': 'C',
    'М': 'V',
    'И': 'B',
    'Т': 'N',
    'Ь': 'M',
    'Б': '<',
    'Ю': '>',
    ',': '?',
    '"': '@',
    '№': '#',
    ';': '$',
    ':': '^',
    '?': '&',
  },
};

export const DEFAULT_PROFILE_ICON = '/assets/svgs/special/profile.svg';
export const DEFAULT_GROUP_ICON = '/assets/svgs/special/group.svg';

export enum MODAL_TYPES {
  PACKET = 'PACKET',
  ADVERT = 'ADVERT',
  ADS = 'ADS',
  CREATE_ADVERT = 'CREATE_ADVERT'
}

export enum CurrencyType {
  UAH = 'UAH',
  USD = 'USD',
  EUR = 'EUR'
}

export const CURRENCY: Currency[] = [
  {
    name: '₴',
    value: CurrencyType.UAH,
  },
  {
    name: '$',
    value: CurrencyType.USD,
  },
  {
    name: '€',
    value: CurrencyType.EUR,
  },
];

export const CURRENCY_CODE: Currency[] = [
  {
    name: 'UAH',
    value: CurrencyType.UAH,
  },
  {
    name: 'USD',
    value: CurrencyType.USD,
  },
  {
    name: 'EUR',
    value: CurrencyType.EUR,
  },
];

export const CURRENCY_SYMBOLS: Record<string, string> = {
  'UAH': '₴',
  'EUR': '€',
  'USD': '$',
};

export const CURRENCY_NAMES: Record<string, string> = {
  'UAH': '₴',
  'EUR': 'eur.',
  'USD': 'usd.',
};

export enum CURRENCY_TYPE {
  UAH = 'UAH',
  EUR = 'EUR',
  USD = 'USD',
}

export const LIST_CA: any[] = liveObject(() => ([
  { value: 'text', name: activeTranslations.list_ca.text },
  { value: 'link', name: activeTranslations.list_ca.link },
  {
    value: 'textarea',
    name: activeTranslations.list_ca.textarea,
    is_view_disabled: true,
  },
  { value: 'checkbox', name: activeTranslations.list_ca.checkbox },
  // { value: 'number', name: 'Число' },
  // { value: 'date', name: 'Дата та час' },
  // { value: 'lists', name: 'Список' },
  // { value: 'checkbox', name: 'Чекбокс' },
  // { value: 'radio', name: 'Радіо' },
]));

export enum APPLICATION_STATUS {
  INSTALLED = 'INSTALLED',
  UNINSTALLED = 'UNINSTALLED',
  READY = 'READY',
  WAIT_PAY = 'WAIT_PAY',
  WAIT_MANAGER = 'WAIT_MANAGER',
}

export enum PERMISSIONS {
  TEAM_ACCESS = 'access_team',
  TEAM_ACTION = 'action_team',
  ROLE_CHANGE_OWN_ROLE_ACCESS = 'access_change_own_role',
  APPS_ACTION = 'action_apps',
  APPS_ACCESS = 'access_apps',
  INTEGRATION_ACCESS = 'access_integration',
  CASH_REGISTER_OPERATIONS = 'cash_register_operations',
  CRM_ACCESS = 'access_crm',
  CRM_DEAL = 'access_deal',
  CONTACTS_ACCESS = 'access_contacts',
  LOGISTICS_ACCESS = 'access_logistics',
  PAYMENT_ACCESS = 'access_payment',
  CHANNEL_GROUPS_CHANGE_OWN_ACCESS = 'access_change_own_channel_groups',
  CHANNELS_ACCESS = 'access_channels',
  CHANNELS_ACTION = 'action_channels',
  SETTINGS_ACCESS = 'access_settings',
  AUTOMATION_ACCESS = 'access_automation',
  AUTOMATION_ACTION = 'action_automation',
  FILES_ACCESS = 'access_files',
  FILES_ACTION = 'action_files',
  CHATS_ACCESS = 'access_chats',
  DISTRIBUTE_CHATS = 'distribute_chats',
}

export const SUCCESS_RESPONSE = 'success';

export enum ADVERT_PLANNER_STATUS {
  CREATED = 'CREATED',
  WAITING = 'WAITING',
  FAIL = 'FAIL',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  DRAFT = 'DRAFT',
  PROGRESS = 'PROGRESS'
}

export const ADVERT_PLANNER_TYPE: any = liveObject(() => ({
  ACTIVATION: activeTranslations.advert_planner_type.activation,
  DEACTIVATION: activeTranslations.advert_planner_type.deactivation,
  PUSH_UP: activeTranslations.advert_planner_type.push_up,
  PACKET: activeTranslations.advert_planner_type.packet,
  ADS: activeTranslations.advert_planner_type.ads,
  CREATE_ADVERT: activeTranslations.advert_planner_type.creation,
}));

export const CALL_STATUS: any = liveObject(() => ({
  ANSWERED: activeTranslations.call_status.answered,
  'NO ANSWER': activeTranslations.call_status.no_answer,
  PROPER: activeTranslations.call_status.proper,
  REPEATED: activeTranslations.call_status.repeated,
  BUSY: activeTranslations.call_status.busy,
}));

export const ALIAS_EVENTS: any = liveObject(() => ({
  CREATED: activeTranslations.alias_events.created,
  UPDATED: activeTranslations.alias_events.updated,
  ADDED: activeTranslations.alias_events.added,
  REMOVED: activeTranslations.alias_events.removed,
}));

export const ALIAS: any = liveObject(() => ({
  COLUMN: activeTranslations.alias.column,
  COLUMN_ID: activeTranslations.alias.column_id,
  CONTACT: activeTranslations.alias.contact,
  CONTACT_ID: activeTranslations.alias.contact_id,
  FUNNEL: activeTranslations.alias.funnel,
  FUNNEL_ID: activeTranslations.alias.funnel_id,
  LEAD: activeTranslations.alias.lead,
  DEAL: activeTranslations.alias.deal,
  PRICE: activeTranslations.alias.price,
  CURRENCY: activeTranslations.alias.currency,
  TITLE: activeTranslations.alias.title,
  NAME: activeTranslations.alias.name,
  BG_COLOR: activeTranslations.alias.bg_color,
  TEXT_COLOR: activeTranslations.alias.text_color,
  COMMENT: activeTranslations.alias.comment,
}));

export interface TChannelTypeObject {
  name: string,
  integration_key: string,
  img_url: string,
}

export enum CHANNEL_TYPE {
  OLX = 'OLX',
  RIA = 'RIA',
  TELEGRAM = 'TELEGRAM',
  TELEGRAM_BOT = 'TELEGRAM_BOT',
  WIDGET = 'WIDGET',
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  VIBER = 'VIBER',
  WHATSAPP = 'WHATSAPP',
  PROM = 'PROM',
  TIKTOK = 'TIKTOK',
  RINGOSTAT = 'RINGOSTAT',
  BINOTEL = 'BINOTEL',
  UNITALK = 'UNITALK',
  ZADARMA = 'ZADARMA',
  UNKNOWN = 'UNKNOWN'
}

export const CHANNEL_TYPES_OBJECT: Record<CHANNEL_TYPE, TChannelTypeObject> = {
  [CHANNEL_TYPE.OLX]: {
    img_url: '/assets/svgs/integrations/olx_off_color.svg',
    name: 'channels_type.olx',
    integration_key: 'integration-olx',
  },
  [CHANNEL_TYPE.RIA]: {
    img_url: '/assets/svgs/integrations/ria_off_color.png',
    name: 'channels_type.ria',
    integration_key: 'integration-ria',
  },
  [CHANNEL_TYPE.TELEGRAM_BOT]: {
    img_url: '/assets/svgs/integrations/telegram_bot_v2.png',
    name: 'channels_type.telegram_bot',
    integration_key: 'integration-telegram-bot',
  },
  [CHANNEL_TYPE.TELEGRAM]: {
    img_url: '/assets/svgs/integrations/telegram.svg',
    name: 'channels_type.telegram',
    integration_key: 'integration-telegram-user',
  },
  [CHANNEL_TYPE.WIDGET]: {
    img_url: '/assets/svgs/integrations/widget.png',
    name: 'channels_type.widget',
    integration_key: 'integration-widget',
  },
  [CHANNEL_TYPE.INSTAGRAM]: {
    img_url: '/assets/svgs/integrations/instagram.svg',
    name: 'channels_type.instagram',
    integration_key: 'integration-instagram',
  },
  [CHANNEL_TYPE.FACEBOOK]: {
    img_url: '/assets/svgs/integrations/facebook.svg',
    name: 'channels_type.facebook',
    integration_key: 'integration-facebook',
  },
  [CHANNEL_TYPE.VIBER]: {
    img_url: '/assets/svgs/integrations/viber.svg',
    name: 'channels_type.viber',
    integration_key: 'integration-viber',
  },
  [CHANNEL_TYPE.WHATSAPP]: {
    img_url: '/assets/svgs/integrations/whatsapp.svg',
    name: 'channels_type.whatsapp',
    integration_key: 'integration-whatsapp',
  },
  [CHANNEL_TYPE.PROM]: {
    img_url: '/assets/svgs/integrations/prom.svg',
    name: 'channels_type.prom',
    integration_key: 'integration-prom',
  },
  [CHANNEL_TYPE.TIKTOK]: {
    img_url: '/assets/svgs/integrations/tiktok.svg',
    name: 'channels_type.tiktok',
    integration_key: 'integration-tiktok',
  },
  [CHANNEL_TYPE.RINGOSTAT]: {
    img_url: '/assets/svgs/integrations/ringostat-logo.svg',
    name: 'channels_type.ringostat',
    integration_key: 'integration-ringostat-channel',
  },
  [CHANNEL_TYPE.BINOTEL]: {
    img_url: '/assets/svgs/integrations/binotel.png',
    name: 'channels_type.binotel',
    integration_key: 'integration-binotel-channel',
  },
  [CHANNEL_TYPE.UNITALK]: {
    img_url: '/assets/svgs/integrations/unitalk.svg',
    name: 'channels_type.unitalk',
    integration_key: 'integration-unitalk-channel',
  },
  [CHANNEL_TYPE.ZADARMA]: {
    img_url: '/assets/svgs/integrations/zadarma.png',
    name: 'channels_type.zadarma',
    integration_key: 'integration-zadarma-channel',
  },
  [CHANNEL_TYPE.UNKNOWN]: {
    name: 'UNKNOWN',
    integration_key: 'UNKNOWN',
    img_url: 'UNKNOWN',
  },
};

export const SITE_STATUSES: any = liveObject(() => ({
  PUBLISHED: { lang: activeTranslations.site_statuses.published, color: 'green' },
  ARCHIVED: { lang: activeTranslations.site_statuses.archived, color: 'gray' },
  NOT_PUBLISHED: {
    lang: activeTranslations.site_statuses.not_published,
    color: 'orange',
  },
  NOT_PAID: { lang: activeTranslations.site_statuses.not_paid, color: 'red' },
}));

export const UPLOAD_FILE_TYPES: Record<string, IUploadFileCondition> = {
  OLX: { max_upload_files: 9, allowed_media_types: ['image/*'] },
  TICKET: { max_upload_files: 4, allowed_media_types: ['image/*'] },
  RIA: { allowed_media_types: ['image/*'] },
  AUTO_RIA: { allowed_media_types: ['image/*'] },
  DOM_RIA: { allowed_media_types: ['image/*'] },
  AGRO_RIA: { allowed_media_types: ['image/*'] },
  TELEGRAM_BOT: { max_upload_files: 10 },
  TELEGRAM_USER: {
    max_upload_files: 10,
    max_upload_size: 20,
    is_file_choice: true,
    solo_media_types: ['image/webp', 'video/webm'],
  },
  INSTAGRAM: { allowed_media_types: ['image/*', 'video/*', 'audio/wav'], max_upload_files: 10 },
  VIBER: { allowed_media_types: ['image/*', 'video/*', 'application/*', 'text/*'], max_upload_files: 1 },
  JESPACE: { max_upload_files: 10 },
  PROM: { allowed_media_types: ['image/*'], max_upload_files: 1 },
};

export const UPLOAD_FILE_ICONS: Record<string, string> = {
  csv: '/assets/svgs/file-icons/CSV.svg',
  msword: '/assets/svgs/file-icons/DOC.svg',
  'x-ms-dos-executable': '/assets/svgs/file-icons/EXE.svg',
  gif: '/assets/svgs/file-icons/GIF.svg',
  jpg: '/assets/svgs/file-icons/JPG.svg',
  pjpeg: '/assets/svgs/file-icons/JPG.svg',
  mpeg: '/assets/svgs/file-icons/MP3.svg',
  'vnd.oasis.opendocument.formula': '/assets/svgs/file-icons/ODF.svg',
  pdf: '/assets/svgs/file-icons/PDF.svg',
  png: '/assets/svgs/file-icons/PNG.svg',
  tiff: '/assets/svgs/file-icons/TIFF.svg',
  plain: '/assets/svgs/file-icons/TXT.svg',
  webp: '/assets/svgs/file-icons/WEBP.svg',
  'vnd.ms-excel': '/assets/svgs/file-icons/XLS.svg',
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet': '/assets/svgs/file-icons/XLSX.svg',
  zip: '/assets/svgs/file-icons/ZIP.svg',

  video: '/assets/svgs/file-icons/VIDEO.svg',
  image: '/assets/svgs/file-icons/IMAGE.svg',
  audio: '/assets/svgs/file-icons/AUDIO.svg',
  document: '/assets/svgs/file-icons/FILE.svg',
  file: '/assets/svgs/file-icons/FILE.svg',
};

export enum DEVICE_TYPE {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
  UNKNOWN = 'unknown',
}

export enum CHANNEL_STATUS {
  LOADING = 'LOADING',
  CREATED = 'CREATED',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  EXPIRED = 'EXPIRED',
  CLOSED = 'CLOSED',
  PAUSED = 'PAUSED',
  SYNCING = 'SYNCING',
  PROCESSING = 'PROCESSING',
}

/** Presence shown as a dot on app-avatar; `users.status` from the backend is currently `online` | `offline` */
export type PresenceStatus = 'online' | 'offline' | 'idle' | 'busy' | 'invisible';

export const PRESENCE_STATUS_CLASSES: Record<PresenceStatus, string> = {
  online: 'bg-green-500',
  idle: 'bg-amber-400',
  busy: 'bg-red-500',
  invisible: 'bg-white !border-gray-400',
  offline: 'bg-gray-400',
};

/** Company setting `name_format`: order of first and last name in full names */
export enum NAME_FORMAT {
  FIRST_LAST = 'first_last',
  LAST_FIRST = 'last_first',
}

export enum USER_COMPANY_STATUS {
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
}

/** Pickers and filters should only offer employees who can actually work, so they request this status */
export const ACTIVE_EMPLOYEES_PARAMS = { status: USER_COMPANY_STATUS.ACTIVE };

export const MEMBERSHIP_STATUS_CHIPS: Record<USER_COMPANY_STATUS, { label: string; color: string; icon: string }> = {
  [USER_COMPANY_STATUS.INVITED]: { label: 'membership_status_invited', color: '#d97706', icon: 'schedule_send' },
  [USER_COMPANY_STATUS.ACTIVE]: { label: 'membership_status_active', color: '#16a34a', icon: 'check_circle' },
  [USER_COMPANY_STATUS.SUSPENDED]: { label: 'membership_status_suspended', color: '#dc2626', icon: 'block' },
};

export const defaultTheme: ITheme = {
  name: 'Dark-silk',
  img_url: '/assets/themes/dark-silk.jpg',
};

export const WIDGET_TIME: any = liveObject(() => ({
  THREE: activeTranslations.time.three,
  FIVE: activeTranslations.time.five,
  TEN: activeTranslations.time.ten,
  FIFTEEN: activeTranslations.time.fifteen,
  THIRTY: activeTranslations.time.thirty,
}));

export const WIDGET_INPUTS: any = liveObject(() => ({
  TEXT: activeTranslations.text_input,
  COMMENT: activeTranslations.textarea,
}));

export const WIDGETS: any = liveObject(() => ({
  FORM: activeTranslations.form_widget,
  CHAT: activeTranslations.chat_widget,
}));

export enum WIDGET_TYPES {
  FORM = 'FORM',
  CHAT = 'CHAT',
}

export enum MESSAGE_TYPES {
  TEXT = 'TEXT',
  TEXT_AI = 'TEXT_AI',
  TEXT_COMMENT = 'TEXT_COMMENT',
  RIA_AUCTION = 'RIA_AUCTION',
  RIA_AUCTION_AGREED = 'RIA_AUCTION_AGREED',
  RIA_AUCTION_ACCEPT = 'RIA_AUCTION_ACCEPT',
  RIA_AUCTION_DECLINE = 'RIA_AUCTION_DECLINE',
  RIA_TRADE = 'RIA_TRADE',
  RIA_TRADE_ACCEPT_BUYER = 'RIA_TRADE_ACCEPT_BUYER',
  RIA_TRADE_DECLINE_BUYER = 'RIA_TRADE_DECLINE_BUYER',
  RIA_TRADE_ACCEPT = 'RIA_TRADE_ACCEPT',
  RIA_TRADE_DECLINE = 'RIA_TRADE_DECLINE',
  NO_MESSAGES = 'NO_MESSAGES',
  SYSTEM = 'SYSTEM',
}

export enum ATTACHMENTS_TYPES {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  ROUND = 'ROUND',
  STICKER = 'STICKER',
  DOCUMENT = 'DOCUMENT',
  POST = 'POST',
  UNKNOWN = 'UNKNOWN',
}

export enum ADS_TYPES {
  VAS = 'vas',
  BUNDLE = 'bundle',
}

export enum BUNDLE_TYPES {
  BASIC = 'bundle_basic',
  OPTIMUM = 'bundle_optimum',
  PREMIUM = 'bundle_premium',
}

export enum DOWNLOAD_MEDIA_TYPE {
  MEDIA = 'MEDIA',
  PROFILE_PHOTO = 'PROFILE_PHOTO',
}

export const DEFAULT_PROFILE_COLOR = '#757575';
export const PROFILE_COLORS = [
  '#D45246',
  '#F68136',
  '#6C61DF',
  '#46BA43',
  '#5CAFFA',
  '#408ACF',
  '#D95574',
];

export enum ERROR_CODES {
  INTEGRATION_ALREADY_EXISTS = 'INTEGRATION_ALREADY_EXISTS',
  TTN_NOT_FOUND = 'TTN_NOT_FOUND',
}

export const MAX_CACHE_SIZE_MB = 50;
export enum CACHE_NAMES {
  CHAT_MEDIA = 'chat-media',
  JESPACE = 'jespace-media',
  CHAT_PROFILE_PHOTO = 'chat-profile-photo',
  AVATAR_IMAGE = 'avatar-image',
}

export const DEFAULT_TOAST_TIMEOUT: number = 5000;

export enum CHAT_SUB_TYPES {
  PRIVATE = 'PRIVATE',
  GROUP = 'GROUP',
  CHANNEL = 'CHANNEL',
}


export enum MESSAGE_STATUS {
  SEND = 'SEND',
  WAIT = 'WAIT',
  FAIL = 'FAIL',
}

export enum SEND_ACTION_TYPE {
  SEND = 'SEND',
  SEND_MESSAGE_BY_COMMENT_TO_DIRECT = 'SEND_MESSAGE_BY_COMMENT_TO_DIRECT',
  REPLY = 'REPLY',
  REPLY_COMMENT = 'REPLY_COMMENT',
  EDIT = 'EDIT',
  VOICE = 'VOICE',
}

export enum EXTERNAL_ID_PREFIX {
  TG_USER = 'TGUSER-',
  TG_BOT = 'TGBOT-',
  OLX_UA = 'OLX-UA-',
  RIA = 'RIA-',
  INSTAGRAM = 'INST-',
  INSTAGRAM_COMMENT = 'INST-COMMENT-',
  FACEBOOK = 'FB-',
  FACEBOOK_COMMENT = 'FB-COMMENT-',
  TIKTOK_COMMENT = 'TIKTOK-COMMENT-',
  WHATSAPP = 'WHATSAPP-P-',
  WHATSAPP_BUSINESS = 'WHATSAPP-B-',
}

export enum AUTOMATION_TRIGGER {
  GET_PHONE = 'GET_PHONE',
  GET_EMAIL = 'GET_EMAIL',
  GET_ADDRESS = 'GET_ADDRESS',
  GET_KEY_WORDS = 'GET_KEY_WORDS',
  GET_FIRST_MESSAGE = 'GET_FIRST_MESSAGE',
  GET_ALL_MESSAGE = 'GET_ALL_MESSAGE',
  GET_AI_REPLY = 'GET_AI_REPLY',
  GET_CRM_MANAGER_REPLY = 'GET_CRM_MANAGER_REPLY',
  GET_AI_CRM_MANAGER_REPLY = 'GET_AI_CRM_MANAGER_REPLY',

  // AUTOMATION_TYPE.CRM triggers (leads / deals)
  CARD_CREATED = 'CARD_CREATED',
  CARD_MOVED = 'CARD_MOVED',
  CARD_ASSIGNED = 'CARD_ASSIGNED',
  CARD_UNASSIGNED = 'CARD_UNASSIGNED',
  CARD_PRICE_CHANGED = 'CARD_PRICE_CHANGED',
  CARD_CUSTOM_FIELD_CHANGED = 'CARD_CUSTOM_FIELD_CHANGED',
  CARD_CLOSED_SUCCESS = 'CARD_CLOSED_SUCCESS',
  CARD_CLOSED_FAILED = 'CARD_CLOSED_FAILED',
  CARD_STAGNATED = 'CARD_STAGNATED',
}

export enum AUTOMATION_ACTION {
  MOVE_LEAD = 'MOVE_LEAD',
  MOVE_DEAL = 'MOVE_DEAL',
  MOVE_DEAL_TO_BITRIX = 'MOVE_DEAL_TO_BITRIX',
  CREATE_LEAD = 'CREATE_LEAD',
  CREATE_DEAL = 'CREATE_DEAL',
  REPLY_MESSAGE = 'REPLY_MESSAGE',
  SEND_MESSAGE = 'SEND_MESSAGE',
  GENERATE_AI = 'GENERATE_AI',
  SEND_TELEGRAM_NOTIFICATION = 'SEND_TELEGRAM_NOTIFICATION',
  CLOSE_CHAT = 'CLOSE_CHAT',
  ADD_CHAT_TAG = 'ADD_CHAT_TAG',
  REMOVE_CHAT_TAG = 'REMOVE_CHAT_TAG',

  // AUTOMATION_TYPE.CRM actions (leads / deals)
  MOVE_CARD = 'MOVE_CARD',
  ASSIGN_CARD_MANAGER = 'ASSIGN_CARD_MANAGER',
  CREATE_CARD_TASK = 'CREATE_CARD_TASK',
  ADD_CARD_COMMENT = 'ADD_CARD_COMMENT',
  SEND_CARD_NOTIFICATION = 'SEND_CARD_NOTIFICATION',
}

export enum AUTOMATION_TYPE {
  CHAT = 'CHAT',
  CRM = 'CRM',
}

export enum MessageSocketAction {
  SEEN = 'SEEN',
  REACTION = 'REACTION',
  DELETED = 'DELETED',
  TRANSCRIPTION = 'TRANSCRIPTION',
  TRANSLATION = 'TRANSLATION',
}

export enum TRANSCRIPTION_STATUS {
  PENDING = 'PENDING',
  DONE = 'DONE',
  FAILED = 'FAILED',
}

export enum INST_REACTION_ACTION {
  REACT = 'react',
  UNREACT = 'unreact'
}

export const INSTAGRAM_REACTIONS = {
  LOVE: { code: 'love', emoji: '❤️' } as TReaction,
};

export interface TChannelStatusBadge {
  textKey: string,
  color: string,
}

export const CHANNEL_STATUS_OBJECT: Record<CHANNEL_STATUS, TChannelStatusBadge> = { //NOTE USE channel_status_new!!!!!
  [CHANNEL_STATUS.LOADING]: { textKey: 'loading', color: 'darkgrey' },
  [CHANNEL_STATUS.CREATED]: { textKey: 'created', color: 'darkgrey' },
  [CHANNEL_STATUS.CONNECTED]: { textKey: 'connected', color: 'green' },
  [CHANNEL_STATUS.DISCONNECTED]: { textKey: 'disconnected', color: 'gray' },
  [CHANNEL_STATUS.EXPIRED]: { textKey: 'expired', color: 'gray' },
  [CHANNEL_STATUS.CLOSED]: { textKey: 'closed', color: 'gray' },
  [CHANNEL_STATUS.PAUSED]: { textKey: 'paused', color: 'gray' },
  [CHANNEL_STATUS.SYNCING]: { textKey: 'syncing', color: 'green' },
  [CHANNEL_STATUS.PROCESSING]: { textKey: 'processing', color: 'darkgrey' },
};

export const DRAFT_ADVERT_LOCAL_STORAGE_KEY = 'action-advert-draft';

export enum FUNNEL_ACTION {
  DELETE = 'DELETE',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export interface ResponseItemsWithParams<T> {
  items: T[];
  total: number;
  size: number;
  page: number;
}

export interface ActionListItem<T, K> {
  label: string;
  method: keyof T;
  icon: string;
  color_icon: string;
  disabled?: (items: K[]) => boolean;
  unseen?: (items: K[], crm?: CrmService) => boolean;
  action?: (item?: K) => void;
  bulk?: boolean;
  unique_action?: boolean;
}

export enum VIBER_SOCKET_ERROR {
  CHAT_IS_NOT_AVAILABLE = 'CHAT_IS_NOT_AVAILABLE',
  VIBER_SEND_MESSAGE_ERROR = 'VIBER_SEND_MESSAGE_ERROR',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export enum PAYMENT_TYPE {
  TOKEN = 'token',
  TARIFF = 'tariff',
  CHANNEL = 'channel',
}

export const PHONES_FOR_INPUT = [
  { title: '+380', code: 'UA', link: 'assets/svgs/countries/UA.svg', value: '380' },
  { title: '+48', code: 'PL', link: 'assets/svgs/countries/PL.svg', value: '48' },
];

export const entityIcons: Record<string, string> = {
  [CHAT_EXTERNAL_TYPE.OLX]: '/assets/svgs/integrations/olx_off_color.svg',
  [CHAT_EXTERNAL_TYPE.AUTO_RIA_WH]: '/assets/svgs/integrations/autoria_old_off_color.png',
  [CHAT_EXTERNAL_TYPE.DOM_RIA_WH]: '/assets/svgs/integrations/dimria_old_off_color.png',
  [CHAT_EXTERNAL_TYPE.AGRO_RIA_WH]: '/assets/svgs/integrations/agroria_old_off_color.png',
  [CHAT_EXTERNAL_TYPE.RIA_WH]: '/assets/svgs/integrations/ria_old_off_color.png',
  [CHAT_EXTERNAL_TYPE.AUTO_RIA]: '/assets/svgs/integrations/autoria_off_color.png',
  [CHAT_EXTERNAL_TYPE.DOM_RIA]: '/assets/svgs/integrations/dimria_off_color.png',
  [CHAT_EXTERNAL_TYPE.AGRO_RIA]: '/assets/svgs/integrations/agroria_off_color.png',
  [CHAT_EXTERNAL_TYPE.RIA]: '/assets/svgs/integrations/ria_off_color.png',
  [CHAT_EXTERNAL_TYPE.TELEGRAM_USER]: '/assets/svgs/integrations/telegram.svg',
  [CHAT_EXTERNAL_TYPE.TELEGRAM_BOT]: '/assets/svgs/integrations/telegram_bot.png',
  [CHAT_EXTERNAL_TYPE.CHAT_WIDGET]: '/assets/svgs/integrations/widget.jpg',
  [CHAT_EXTERNAL_TYPE.INSTAGRAM]: '/assets/svgs/integrations/instagram.svg',
  [CHAT_EXTERNAL_TYPE.FACEBOOK]: '/assets/svgs/integrations/facebook.svg',
  [CHAT_EXTERNAL_TYPE.VIBER]: '/assets/svgs/integrations/viber.svg',
  [CHAT_EXTERNAL_TYPE.WHATSAPP]: '/assets/svgs/integrations/whatsapp.svg',
  [CHAT_EXTERNAL_TYPE.PROM]: '/assets/svgs/integrations/prom.svg',
  [CHAT_EXTERNAL_TYPE.TIKTOK]: '/assets/svgs/integrations/tiktok.svg',
};

export enum ANOTHER_CRM_TYPE {
  KEY_CRM = 'KEY_CRM',
  SALES_DRIVE = 'SALES_DRIVE',
  KEEPINCRM = 'KEEPINCRM',
  UNKNOWN = 'UNKNOWN',
}

export enum NEURON_INTEGRATION_STATUS {
  CREATED = 'CREATED',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  EXPIRED = 'EXPIRED',
  CLOSED = 'CLOSED',
  PAUSED = 'PAUSED',
  SYNCING = 'SYNCING',
  PROCESSING = 'PROCESSING',
}

export const NEURON_INTEGRATION_STATUS_OBJECT: Record<NEURON_INTEGRATION_STATUS, TChannelStatusBadge> = {
  [NEURON_INTEGRATION_STATUS.CREATED]: { textKey: 'created', color: 'darkgrey' },
  [NEURON_INTEGRATION_STATUS.CONNECTED]: { textKey: 'connected', color: 'green' },
  [NEURON_INTEGRATION_STATUS.DISCONNECTED]: { textKey: 'disconnected', color: 'gray' },
  [NEURON_INTEGRATION_STATUS.EXPIRED]: { textKey: 'expired', color: 'gray' },
  [NEURON_INTEGRATION_STATUS.CLOSED]: { textKey: 'closed', color: 'gray' },
  [NEURON_INTEGRATION_STATUS.PAUSED]: { textKey: 'paused', color: 'gray' },
  [NEURON_INTEGRATION_STATUS.SYNCING]: { textKey: 'syncing', color: 'green' },
  [NEURON_INTEGRATION_STATUS.PROCESSING]: { textKey: 'processing', color: 'darkgrey' },
};
